import aes from "crypto-js/aes.js";
import Crypto from "crypto-js";

function encrypt(message, key) {
    return aes.encrypt(message, key).toString()
}

function decrypt(encrypted_message, key) {
    return aes.decrypt(encrypted_message, key).toString(Crypto.enc.Utf8)
}

function basicHash(message) {
    return Crypto.SHA256(message).toString()
}

window.encrypt = encrypt
window.decrypt = decrypt
window.basicHash = basicHash
window.aes = aes
window.Crypto = Crypto

export {basicHash, encrypt, decrypt}